// 今日曝瓜 · 演示数据
// 说明：以下为静态占位内容，主题聚焦热点现象与公开事件讨论，不针对具体个人。

export interface Category {
  id: string;
  name: string;
  icon: string;
  desc: string;
  count: number;
  hot: boolean;
}

export const categories: Category[] = [
  { id: "yule", name: "娱乐瓜田", icon: "ri-movie-2-line", desc: "影视角综、明星营业动态与圈内热议", count: 328, hot: true },
  { id: "shiping", name: "影视剧综", icon: "ri-clapperboard-line", desc: "热剧口碑、剧情走向与综艺名场面", count: 216, hot: true },
  { id: "keji", name: "科技圈", icon: "ri-cpu-line", desc: "数码新品、行业大瓜与前沿动态", count: 187, hot: false },
  { id: "zhichang", name: "职场生活", icon: "ri-briefcase-4-line", desc: "打工人日常、求职跳槽与生活百态", count: 254, hot: false },
  { id: "tiyu", name: "体育赛事", icon: "ri-basketball-line", desc: "焦点赛事、名场面与体坛话题", count: 132, hot: false },
  { id: "minsheng", name: "民生热点", icon: "ri-restaurant-2-line", desc: "城市话题、生活消费与身边新鲜事", count: 190, hot: true },
];

export interface TrendItem {
  rank: number;
  title: string;
  tag: string;
  heat: string;
  comments: number;
  rising: boolean;
}

export const hotTrends: TrendItem[] = [
  { rank: 1, title: "短剧为何能霸屏追剧人的下饭时间？", tag: "影视剧综", heat: "2.1亿围观", comments: 8456, rising: true },
  { rank: 2, title: "网红探店排长队：是真好吃还是跟风？", tag: "民生热点", heat: "1.6亿围观", comments: 7210, rising: true },
  { rank: 3, title: "直播带货价格战，消费者真捡到便宜了吗", tag: "科技圈", heat: "1.2亿围观", comments: 5883, rising: true },
  { rank: 4, title: "年轻人把公园逛成新的社交现场", tag: "职场生活", heat: "9800万围观", comments: 4632, rising: true },
  { rank: 5, title: "演唱会抢票的「手速玄学」何时能终结", tag: "娱乐瓜田", heat: "7600万围观", comments: 3975, rising: false },
  { rank: 6, title: "打工人午休一小时能有多少种过法", tag: "职场生活", heat: "6100万围观", comments: 3208, rising: false },
  { rank: 7, title: "热门赛事解说金句，你记得哪一句？", tag: "体育赛事", heat: "5300万围观", comments: 2894, rising: true },
  { rank: 8, title: "家乡小城被拍成「网红打卡地」之后", tag: "民生热点", heat: "4700万围观", comments: 2361, rising: false },
];

export interface FeedPost {
  id: string;
  catId: string;
  cat: string;
  title: string;
  excerpt: string;
  image?: string;
  author: string;
  time: string;
  likes: number;
  comments: number;
  views: number;
  badge?: string;
  featured?: boolean;
}

export const feedPosts: FeedPost[] = [
  {
    id: "f1", catId: "shiping", cat: "影视剧综",
    title: "一部现象级短剧火出圈，追更背后的情绪经济值得深聊",
    excerpt: "从下饭神器到全民话题，短剧凭什么让观众一边嫌弃一边上头？我们盘点了几个爆款套路，也聊聊它到底为什么这么抓人。",
    author: "瓜田里的一颗豆", time: "2 小时前", likes: 3280, comments: 486, views: 128000, badge: "爆款热议",
  },
  {
    id: "f2", catId: "minsheng", cat: "民生热点",
    title: "探店排长队背后：营销造势与真实口味的拉扯",
    excerpt: "打开社交平台全是「排队两小时」的打卡视频，可当热度褪去，店还在吗？我们跟着几位常客聊了聊，真相比想象中复杂。",
    author: "巷口吃瓜妹", time: "5 小时前", likes: 2156, comments: 389, views: 89000, badge: "持续升温",
  },
  {
    id: "f3", catId: "keji", cat: "科技圈",
    title: "直播间里「全网最低价」的水有多深？",
    excerpt: "比价、特供、满减……一套组合拳下来，消费者到底买没买亏？拆解几个常见玩法，教你一眼看穿套路。",
    author: "数码暴走族", time: "8 小时前", likes: 1980, comments: 302, views: 76000, badge: "围观高能",
  },
  {
    id: "f4", catId: "zhichang", cat: "职场生活",
    title: "公园散步正在成为打工人新的「精神按摩」",
    excerpt: "午休去公园、下班去遛弯，越来越多年轻人把自然当作情绪解药。这届打工人，正在重新定义什么是真正的松弛感。",
    author: "格子间路人甲", time: "12 小时前", likes: 1665, comments: 274, views: 54000,
  },
  {
    id: "f5", catId: "yule", cat: "娱乐瓜田",
    title: "年度舞台名场面盘点：谁的高光时刻让你刷了十遍",
    excerpt: "一场晚会、一次颁奖礼，总有几个瞬间值得反复回味。评论区聊聊你心中的「年度名场面」Top1。",
    author: "追光预备役", time: "1 天前", likes: 1432, comments: 518, views: 112000, badge: "瓜友狂刷",
  },
  {
    id: "f6", catId: "tiyu", cat: "体育赛事",
    title: "主场逆转那晚，你在屏幕前喊了什么？",
    excerpt: "从落后到绝杀，竞技体育的戏剧性永远无法排练。收集几位资深球迷的真实观赛记忆，献给每个热泪盈眶的夜晚。",
    author: "看台第七排", time: "1 天前", likes: 1210, comments: 203, views: 47000,
  },
];

export interface Comment {
  id: string;
  user: string;
  avatar: string;
  time: string;
  text: string;
  likes: number;
  replies: number;
}

export const discussComments: Comment[] = [
  { id: "c1", user: "前排吃瓜委员", avatar: "🍉", time: "刚刚", text: "说实话，短剧能火本质是精准拿捏了碎片时间，上下班路上刷两集刚刚好。", likes: 486, replies: 32 },
  { id: "c2", user: "理性围观选手", avatar: "🧊", time: "3 分钟前", text: "套路是一回事，能把套路拍好看也是本事，关键还是剧本和节奏。", likes: 298, replies: 18 },
  { id: "c3", user: "熬夜追更使我快乐", avatar: "🌙", time: "6 分钟前", text: "评论区说它「又土又上头」，但转发到朋友群最多的也是它，这不就说明问题了吗哈哈。", likes: 356, replies: 24 },
  { id: "c4", user: "瓜田不打烊", avatar: "☕", time: "11 分钟前", text: "把流量思维换成产品思维，短剧的下半场才刚开始，拭目以待。", likes: 172, replies: 9 },
  { id: "c5", user: "场外热心群众", avatar: "📣", time: "15 分钟前", text: "建议想入行的先别急着追风口，把用户需求研究明白了再说。", likes: 141, replies: 12 },
];

export interface Testimonial {
  id: string;
  nick: string;
  role: string;
  text: string;
  avatar: string;
}

export const testimonials: Testimonial[] = [
  { id: "t1", nick: "午休摸鱼队长", role: "通勤路上的常客", text: "每天地铁上必刷今日曝瓜，热点抓得又快又全，评论区个个是人才，比正片还有意思。", avatar: "🚇" },
  { id: "t2", nick: "熬夜到天亮", role: "夜猫子围观党", text: "晚上睡不着就爱来这里看大家理性讨论，氛围比想象中友好，很少被带节奏。", avatar: "🌃" },
  { id: "t3", nick: "理性打分bot", role: "三年老瓜友", text: "分类很清楚，想看哪块直接点，热榜和分类分开这点很贴心，UI 也舒服。", avatar: "🎯" },
  { id: "t4", nick: "格子间路人甲", role: "职场话题常驻", text: "很多职场和生活的话题特别能共鸣，评论区一刷就停不下来，已经养成习惯。", avatar: "🪑" },
];

export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  { q: "今日曝瓜上的热点内容是怎么来的？", a: "我们会聚合站内站外广泛讨论的热点现象与公开事件，经过编辑整理后分类呈现，帮你快速了解来龙去脉，再看懂评论区。" },
  { q: "我可以在这里发言或投稿吗？", a: "当然可以。登录状态下可在对应话题参与评论，也可以通过「联系我们」中的投稿通道分享你的见闻或补充信息，编辑会进行审核。" },
  { q: "讨论区有什么发帖规则？", a: "我们倡导理性、文明、友善的表达。请勿发布不实信息、人身攻击、广告引流或侵犯他人隐私的内容，违者将被限制发言。" },
  { q: "如何找到我感兴趣的领域？", a: "首页顶部的分类入口与「热议专区」支持按娱乐、影视、科技、职场、体育、民生等分类浏览，也支持按热度与最新排序。" },
  { q: "网站是免费使用的吗？", a: "是的，浏览与讨论功能完全免费。未来如推出会员增值服务，会提前公告并充分说明权益。" },
];

export const siteName = "今日曝瓜";
export const siteSlogan = "今日曝瓜 · 吃瓜群众聚集地";
export const siteDesc = "围观热点现场，参与瓜友热议，理性吃瓜看透每一个热点事件。";
export const siteEmail = "guawa@today-guawa.example.com";